export default __webpack_public_path__ + "static/media/The Magic Touch By Daniele.bc0fc78a.png";